"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (transparent48v2) { return function (raw) {
    var virtual = transparent48v2.virtual;
    setTimeout(function () {
        virtual.send('heartbeat');
    }, virtual.options.heartbeat);
}; });



// WEBPACK FOOTER //
// ./src/transparent48v2/decode/12.ts